import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { FatalAttraction as FA } from '@vpr/tracking';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { Paragraph } from '@vimeo/iris/typography';

type Props = {
  isOwnerOrAdmin: boolean;
  albumId: number;
  defaultThumbnail?: string;
};

function LiveHero({ isOwnerOrAdmin, albumId, defaultThumbnail }: Props) {
  return (
    <div>
      <Hero thumbnail={defaultThumbnail} />
      {isOwnerOrAdmin && (
        /* @todo: TRANSLATE */
        <OwnerMessage>
          You can add your own videos from{' '}
          <a
            className="all-videos"
            onClick={() => {
              FA.trackClick({
                container: 'showcase',
                component: 'empty_state',
                keyword: 'add_videos',
              });
            }}
            href={`/manage/showcases/${albumId}`}
          >
            All videos
          </a>
          , or add other videos as you discover them on Vimeo.
        </OwnerMessage>
      )}
    </div>
  );
}

export default LiveHero;

const Hero = styled.div<{
  thumbnail?: string;
}>`
  width: 100%;
  height: 50vh;
  min-height: ${rem(600)};
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.11) 0%, rgba(0, 0, 0, 0.86) 100%),
    url(${(props) => props.thumbnail}), linear-gradient(180deg, #eeeeee 0%, #d8d8d8 100%);

  @media only screen and (max-width: 767px) {
    min-height: ${rem(480)};
    height: ${rem(480)};
  }
`;

const OwnerMessage = styled(Paragraph).attrs({ size: '2' })`
  margin: ${rem(80)} auto;
  text-align: center;
  a.all-videos {
    color: ${theme.colors.blue['500']};
  }
`;
